import {useNavigate} from "react-router-dom";

function NotFound() {
  const navigate = useNavigate();

  const goMove = async () => {
    navigate('/main', { replace: true });
  }

  return(
    <div className="container">
      <div id="error" className="page">
        <div className="content-wrap">
          <div className="img-box">
            <img src="/images/products/img-error.png" alt="음식이미지"/>
          </div>
          <p className="t-22-multi fw-b fc-h ta-c">
            <span className="fc-p">404 error</span>
            <br/>페이지를 찾을 수 없어요
          </p>
          <p className="t-16-multi fc-s ta-c"> 페이지를 찾을 수 없어요 <br/>이용에 불편을 드려 죄송해요 </p>
        </div>
      </div>
      <div className="tab-bar-btn-group fixed">
        <div className="btn-group">
          <button onClick={goMove} className="btn-md filled primary" type="button">홈으로 이동</button>
        </div>
      </div>
    </div>
  )
}

export default NotFound;